import api from '../api';

import { ParamsValidateSolicitationDate, ParamsDataValidateSolicitationDate } from 'utils/typeServices';

type response = {
    Data: ParamsDataValidateSolicitationDate;
}

export const PostValidateSolicitationDate = async ({ body }: { body: ParamsValidateSolicitationDate }) => {
    const token = localStorage.getItem('token');

    try {
        const { data } = await api.post<response>(`/v1/Pagamento/ValidateSolicitationDate?CD_TIPO_OCORRENCIA=${body.CD_TIPO_OCORRENCIA}&NR_PLATAFORMA=${body.NR_PLATAFORMA}`, {}, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        return data.Data;
    } catch (error) {
        console.error('error', error);
        return null;
    }
}
